import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(1),
    boxShadow: 'none',
    '@media print': {
      display: 'none',
    },
  },
}));

export default useStyles;
